import type { RouteRecordRaw } from 'vue-router'

const meta = {
  requiresAuth: true,
  requiresAbility: 'view_ai_review_instructions',
}

const rulesRoute: RouteRecordRaw = {
  path: '/rules',
  name: 'Rules',
  component: () => import('@/modules/Rules/RouteRules.vue'),
  children: [
    {
      path: '',
      name: 'RulesLibrary',
      component: () => import('@/modules/Rules/RulesLibrary.vue'),
      meta,
    },
    {
      path: 'new',
      name: 'RulesNew',
      component: () => import('@/modules/Rules/RuleEditor.vue'),
      meta,
    },
    {
      path: ':instructionId',
      name: 'RulesEdit',
      component: () => import('@/modules/Rules/RuleEditor.vue'),
      meta,
    },
  ],
  meta,
}

export default rulesRoute
